<mat-spinner *ngIf="isLoading" [diameter]="26"></mat-spinner>

<button mat-icon-button [matMenuTriggerFor]="notifMenu" *ngIf="pagination">
  <mat-icon aria-label="Notifications" matBadgeColor="warn" *ngIf="pagination.totalRecords > 0"
    [matBadge]="pagination.totalRecords" [matBadgeHidden]="pagination.totalRecords === 0">
    notifications
  </mat-icon>
  <mat-icon aria-label="No notification" *ngIf="pagination.totalRecords === 0">
    notifications_none
  </mat-icon>
</button>

<mat-menu #notifMenu="matMenu" class="notif-menu">
  <ul *ngIf="notifications.length > 0" class="notificationWrapper">
    <li *ngFor="let notification of notifications; index as i" (click)="onNotificationClick(notification)">
      <ng-container *ngIf="notification.type === 6">
        Votre fichier est prêt sur <a routerLink="/documents">votre page de documents</a>
      </ng-container>

      <ng-container *ngIf="notification.type === 7">
        <div class="notificationItem">
          <div (click)="onNotificationClick(notification)">
            La commande {{notification.payload.orderIdentifier}}
            <span [ngClass]="{ 'redBold': notification.payload.reminder === 2 }">
              est en retard <span *ngIf="notification.payload.reminder === 2">(>= 10 min)</span>
            </span>
          </div>
          <mat-icon matTooltip="Supprimer la notification" color="primary"
            (click)="$event.stopPropagation(); clearOne(notification)">delete</mat-icon>
        </div>
      </ng-container>

      <ng-container *ngIf="notification.type === 5">
        <div class="notificationItem">
          <div (click)="onNotificationClick(notification)">
            La commande {{notification.payload.identifier }}
            commence dans 15 minutes
          </div>
          <mat-icon matTooltip="Supprimer la notification" color="primary"
            (click)="$event.stopPropagation(); clearOne(notification)">delete</mat-icon>
        </div>
      </ng-container>

      <hr class="separator" />
    </li>

    <li class="paginatorContainer">
      <div>
        Page {{pagination.pageNumber}} sur {{pagination.totalPages}}
      </div>
      <div class="paginatorButton">
        <button mat-icon-button matTooltip="Page précédente" (click)=" $event.stopPropagation(); fetchPreviousPage()"
          [disabled]="!hasPreviousPage()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button matTooltip="Page suivante" (click)="$event.stopPropagation(); fetchNextPage()"
          [disabled]="!hasNextPage()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </li>

    <li class="actions">
      <button mat-button color="primary" (click)="onClear()">
        Tout marquer comme lu
      </button>
    </li>

  </ul>

  <p *ngIf="notifications.length === 0">Vous n'avez aucune notification.</p>

</mat-menu>
